import * as _ from "lodash";
import * as $ from "jquery";
import * as Backbone from "backbone";
import {AppTypeCollection} from "../../collections/AppTypes";
import {AppCollection} from "../../collections/Apps";
import {GenericDeleteModal} from "./GenericDeleteModal";
import {BaseModifyModalView, BaseModifyModalViewOptions} from "./_BaseModifyModal";


var modalId = 'addOrganizationModal';
interface AddOrganizationModalOptions extends BaseModifyModalViewOptions {
    appCollection: AppCollection;
    org: Backbone.Model;
}

export class AddOrganizationModal extends BaseModifyModalView {

    public options: AddOrganizationModalOptions;

    private appTypeCollection = new AppTypeCollection();
    private template = _.template(require('templates/modals/addOrganization.html'));
    private appTemplate = _.template(require('templates/modals/addOrganizationAppType.html'))
    private collectionLoaded = false;

    constructor(options: AddOrganizationModalOptions) {
        super(<any> _.extend({}, options, {
            tagName: "div",
            events: {
                'shown.bs.modal #addOrganizationModal': 'handleModalShown',
                'hidden.bs.modal #addOrganizationModal': 'handleModalHidden',
                'input .add-organization-modal-organization-name': 'handleNameChange',
                'input .add-organization-modal-custom-idp': 'handleCustomIDPChange',
                'change input[name="idp"]': 'handleIdpChange',
                'click .add-organization-modal-organization-submit': 'handleAddButtonClick',
                'click .delete-organization-modal-organization': 'handleOrganizationDelete'
            }
        }));

        // For the base class methods
        this.modalIdSelector = modalId;
    }

    render() {
        this.$el.html(this.template({
            elementId: modalId,
            organizationCollection: this.options.organizationCollection,
            permissionCollection: this.options.permissionCollection,
            org: this.options.org
        }));

        if (!this.collectionLoaded) {
            $.when(this.appTypeCollection.fetch()).done(() => {
                this.onCollectionLoaded();
            });
        }

        return this;
    }

    private onCollectionLoaded() {
        this.collectionLoaded = true;
        this.$('.modal-footer').removeClass('hidden');
        this.$('.add-organization-modal-content').removeClass('hidden');
        this.$('.modal-form-spinner').addClass('hidden');

        this.appTypeCollection.each((appType) => {
            this.$('.apps-form').append(this.appTemplate({
                appType: appType,
                appCollection: this.options.appCollection,
                org: this.options.org
            }));
        }, this);

        (<any> this.$('[data-toggle="toggle"]')).bootstrapToggle();
        this.handleNameChange();
    }

    private getName() {
        return (<string> this.$('.add-organization-modal-organization-name').val()).trim()
    }

    private getSSODomain() {
        var val = (<string>this.$('.add-organization-modal-email-domain').val()).trim();
        return val ? val : null;
    }

    private getSSOIDP() {
        var domain = this.getSSODomain();
        var val = domain ? (<string>this.$("input[name='idp']:checked").val()).trim() : null;
        return val ? val : null;
    }

    private getSSOIDPType() {
        var idp = this.getSSOIDP();
        if (idp === 'Google' || idp === 'Microsoft') {
            return idp
        } else {
            var val = idp ? (<string>this.$("input[name='idp_type']:checked").val()).trim() : null;
            return val ? val : null;
        }
    }

    private getEnabledApps() {
        var apps = [];
        this.$('.add-organization-modal-content input.app-enable:checked').each(function () {
            apps.push(Number($(this).attr('data-app-type')));
        });
        return apps;
    }

    private getDeletedApps() {
        var apps = [];
        this.$('.add-organization-modal-content input.app-delete:checked').each(function () {
            apps.push(Number($(this).attr('data-app-type')));
        });
        return apps;
    }

    private handleNameChange() {
        var formGroup = this.$('.add-organization-modal-organization-name').parents('.form-group');

        var value = this.getName();
        var org = this.options.organizationCollection.find(function (o) {
            return o.get('name').toLowerCase() === value.toLowerCase()
        });

        if (this.options.org && this.options.org === org) {
            formGroup.removeClass('has-success');
            formGroup.removeClass('has-error')
        } else if (!value.length || org) {
            formGroup.addClass('has-error');
            formGroup.removeClass('has-success');
        } else {
            formGroup.addClass('has-success');
            formGroup.removeClass('has-error');
        }

        this.setSubmitButtonEnabledState();
    }

    // The type of idp was changed
    private handleIdpChange() {
        var customIdp = this.$('.add-organization-modal-custom-idp-radio').is(':checked');
        this.$('.add-organization-modal-custom-idp-type-form-group').toggleClass('hidden', !customIdp);
    }

    // The input for a custom idp was changed
    private handleCustomIDPChange() {
        // Copy input to radio button
        this.$('.add-organization-modal-custom-idp-radio').val(
            this.$('.add-organization-modal-custom-idp').val()
        ).prop('checked', true).trigger('change');
    }

    private setSubmitButtonEnabledState() {
        var errors = this.$('.has-error');
        this.$('.add-organization-modal-organization-submit').prop('disabled', (
            !this.getName().length || errors.length
        ));
    }

    private handleAddButtonClick() {
        this.setFormSubmitted();

        var request = {
            type: "POST",
            url: this.options.organizationCollection.url(),
            data: JSON.stringify({
                name: this.getName(),
                sso_email_domain: this.getSSODomain(),
                sso_idp: this.getSSOIDP(),
                sso_idp_type: this.getSSOIDPType(),
                enable_public_maps: this.options.org ? this.options.org.get('enable_public_maps') : false,
                public_maps_slug: this.options.org ? this.options.org.get('public_maps_slug') : null,
                apps: this.getEnabledApps(),
                'delete': this.getDeletedApps(),
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.refetchCollectionsAndShow(response.organizationId);
            }
        };

        if (this.options.org) {
            request.type = 'PUT';
            request.url += '/' + this.options.org.get('id');
            $.ajax(request);
        } else {
            request.type = 'POST';
            $.ajax(request);
        }
    };

    private handleOrganizationDelete() {
        const self = this;
        var modal = new GenericDeleteModal({
            type: 'Organization',
            name: self.options.org.get('name'),
            func: () => {
                const result = self.options.org.destroy();
                if (typeof result === 'boolean') {
                    return;
                }
                const xhr = <JQueryXHR>result;
                xhr.done(self.refetchCollectionsAndShow);
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    private refetchCollectionsAndShow(organizationId?) {
        var d1 = this.options.installCollection.fetch({reset: true});
        var d2 = this.options.permissionCollection.fetch({reset: true});
        var d3 = this.options.organizationCollection.fetch({reset: true});
        var d4 = this.options.appCollection.fetch({reset: true});

        $.when(d1, d2, d3, d4).done(() => {
            if (!organizationId) organizationId = '';

            var newHash = '#/account/' + organizationId;
            if (location.hash === newHash) {
                Backbone.history.loadUrl();
            } else {
                location.hash = newHash;
            }

            this.hide();
            
            window['App'].Bus.trigger('navigation:update');
        }).fail(() => {
            this.setFormError();
        })
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/AddOrganizationModal.ts